import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const SubmittableAppsRaw = React.lazy(() => import(/* webpackChunkName: "SubmittableApps" */ './SubmittableApps'));
export const SubmittableApps = () => (React.createElement(Page, { title: "Submit Appearance Results", description: "Submit Appearance Results" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(SubmittableAppsRaw, null)))));
